module.exports = __webpack_public_path__ + "static/media/Bell_beaker_mba_england_text_01.b6564226.jpg";